import {Pipe, PipeTransform} from "@angular/core";
import {Participant, ParticipantType} from "@models";

@Pipe({
	name: "simFilter",
	pure: false,
	standalone: false,
})
export class SimFilterPipe implements PipeTransform {
	transform(items: Participant[], value: ParticipantType): Participant[] {
		return SimFilterPipeService.filter(items, value);
	}
}

export class SimFilterPipeService {
	public static filter(items: Participant[], value: ParticipantType): Participant[] {
		if (!items) {
			return [];
		}
		if (value === undefined) {
			return items;
		}
		return items.filter((it) => it.participantType === value);
	}
}
